// extracted by mini-css-extract-plugin
export var active = "_ds-7";
export var container = "_ds-0";
export var evenWidth = "_ds-4";
export var large = "_ds-5";
export var outlet = "_ds-8";
export var slide = "_ds-2";
export var small = "_ds-6";
export var tab = "_ds-3";
export var tabs = "_ds-1";